import { useI18n } from 'hooks/useI18n';
import { UIOfferSkill } from 'interfaces/ui/ui-offer-skill';
import { config } from 'utils/config';
import {
  StyledSkillsItem,
  StyledSkillsItemIcon,
  StyledSkillsItemLevel,
  StyledSkillsItemLevelCaption,
  StyledSkillsItemLevelLadder,
  StyledSkillsItemTitle
} from './SkillsItem.styled';

const SkillsItem = ({ skillsItem }: { skillsItem: UIOfferSkill }) => {
  const { t } = useI18n('job-offer');

  return (
    <StyledSkillsItem>
      {skillsItem.icon && (
        <StyledSkillsItemIcon src={skillsItem.icon} alt={skillsItem.desc} />
      )}

      {!skillsItem.icon && (
        <StyledSkillsItemIcon
          src={config.defaultTechIcon}
          alt={skillsItem.skill}
        />
      )}

      <StyledSkillsItemTitle>{skillsItem.skill}</StyledSkillsItemTitle>

      <StyledSkillsItemLevel>
        <StyledSkillsItemLevelLadder className={'level_' + skillsItem.level} />
        <StyledSkillsItemLevelCaption>
          {skillsItem.level === 1 && <>{t('skills.basic')}</>}
          {skillsItem.level === 2 && <>{t('skills.intermediate')}</>}
          {skillsItem.level === 3 && <>{t('skills.expert')}</>}
        </StyledSkillsItemLevelCaption>
      </StyledSkillsItemLevel>
    </StyledSkillsItem>
  );
};

export default SkillsItem;
